import { Row, Col, Card, Typography, Form, Input, Button, Select, Spin } from "antd";
import { CheckCircleFilled } from "@ant-design/icons";
import axios from "axios";
import React, { useState, useContext, useEffect } from "react";
import Loader from "../components/loader";
import { useLocation, useHistory } from "react-router-dom";
import { userContext } from "../context/UserContext";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FileExcelOutlined } from "@ant-design/icons";
import { message, Upload } from "antd";
import Swal from "sweetalert2";

const Deposits = () => {
  const { Title, Text } = Typography;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [bulkloading, setBulkLoading] = useState(false);
  const [phone, setPhone] = useState("");
  const [amount, setAmount] = useState("");
  const [provider, setProvider] = useState("");
  const [file, setFile] = useState();
  const [lookupLoading, setLookupLoading] = useState(false);
  const [lookupResult, setLookupResult] = useState(null);
  const [lookupFailed, setLookupFailed] = useState(false);
  const [providerTouched, setProviderTouched] = useState(false);
  const location = useLocation();
  const history = useHistory();
  const { Option } = Select;
  const { setPerson, person, updateCgrate } = useContext(userContext);
  const token = localStorage.getItem("access_token");
  const { Dragger } = Upload;

  const props = {
    name: "file",
    multiple: false,
    beforeUpload: (file) => {
      const isCSV = file.type === "text/csv" || file.name.endsWith(".csv");

      if (!isCSV) {
        message.error("You can only upload CSV files!");
      }

      return isCSV;
    },
    customRequest(info) {
      info.onSuccess();

      setFile(info.file);
    },
    onChange(info) {
      const { status } = info.file;
      if (status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (status === "done") {
        //message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
  };

  // Mirrors the prefix table paysmartserver itself uses (search "097" || "077" in
  // routes/operationRoute.js) -- kept in sync manually since there's no shared config.
  const detectProvider = (digits) => {
    const prefix = digits.slice(0, 3);
    if (["097", "077"].includes(prefix)) return "Airtel";
    if (["096", "076"].includes(prefix)) return "MTN";
    if (["095", "075", "021"].includes(prefix)) return "Zamtel";
    return null;
  };

  const handlePhoneChange = (e) => {
    const value = e.target.value;
    setPhone(value);
    if (!providerTouched) {
      const detected = detectProvider(value);
      if (detected) {
        setProvider(detected);
        form.setFieldsValue({ provider: detected });
      }
    }
  };

  const handleProviderChange = (value) => {
    setProvider(value);
    setProviderTouched(true);
  };

  const handleAmountChange = (value) => {
    setAmount(value);
  };

  // Look up the recipient's registered name before the money is sent, so the sender can visually
  // confirm they've got the right person. Advisory only -- never blocks submission, and a
  // lookup failure is shown quietly rather than as an error toast.
  useEffect(() => {
    const cleanPhone = (phone || "").replace(/\D/g, "");
    if (cleanPhone.length !== 10 || !provider) {
      setLookupResult(null);
      setLookupFailed(false);
      return;
    }

    setLookupResult(null);
    setLookupFailed(false);
    setLookupLoading(true);

    const timer = setTimeout(() => {
      axios
        .post(
          `${process.env.REACT_APP_SERVER}/operation/lookup`,
          { account: cleanPhone, provider },
          { headers: { Authorization: `Bearer ${token}` } },
        )
        .then((response) => {
          if (response.data.success) {
            setLookupResult(response.data.data);
          } else {
            setLookupFailed(true);
          }
        })
        .catch(() => {
          setLookupFailed(true);
        })
        .finally(() => {
          setLookupLoading(false);
        });
    }, 600);

    return () => {
      clearTimeout(timer);
      setLookupLoading(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [phone, provider]);

  const onFileUploaded = async (values) => {
    const fileContent = await readUploadedFile(file);

    // Parse CSV and calculate sum
    const amounts = parseCSVAndSum(fileContent);
    const accounts = parseCSVAndCountRows(fileContent);

    Swal.fire({
      title: "Bulk Deposit",
      text: `Deposit K${amounts} total for ${accounts} accounts?`,
      icon: "info",
      showCancelButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        onBulkFinish(values, amounts, accounts);
      }
    });
  };

  const parseCSVAndSum = (csvContent) => {
    const rows = csvContent.split("\n");
    let sum = 0;

    for (let i = 1; i < rows.length; i++) {
      const columns = rows[i].split(",");
      const amount = parseFloat(columns[2]);

      if (!isNaN(amount)) {
        sum += amount;
      }
    }

    return sum;
  };

  const parseCSVAndCountRows = (csvContent) => {
    const rows = csvContent.split("\n");
    let rowCount = 0;

    for (let i = 1; i < rows.length; i++) {
      const columns = rows[i].split(",");

      // Check if the row has valid data, adjust this condition based on your CSV structure
      if (columns.length > 1 && columns[1].trim() !== "") {
        rowCount++;
      }
    }

    return rowCount;
  };

  const readUploadedFile = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (event) => {
        resolve(event.target.result);
      };

      reader.onerror = (error) => {
        reject(error);
      };

      reader.readAsText(file);
    });
  };

  const onBulkFinish = async (values, amounts, accounts) => {
    if (parseFloat(amounts) > parseFloat(person.balance) - 5) {
      toast.error("Insufficient Funds", {
        position: toast.POSITION.TOP_LEFT,
      });
    } else {
      setBulkLoading(true);

      const formData = new FormData();

      const deductions = accounts * 5;

      const adminBalance =
        parseFloat(person.balance) - parseFloat(amounts) - deductions;

      formData.append("myfile", file);
      formData.append("companyname", person.companyname);
      formData.append("token", token);
      formData.append("balance_id", person.balance_id);
      formData.append("balance", person.balance);
      formData.append("newbalance", adminBalance);

      axios
        .post(
          `${process.env.REACT_APP_SERVER}/operation/bulkdeposit`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token}`,
            },
          }
        )

        .then((response) => {
          setBulkLoading(false);

          Swal.fire({
            title: "Bulk Deposit",
            text: "Operation Complete",
            icon: "success",
          }).then((result) => {
            if (result.isConfirmed) {
              updateCgrate();
              refreshBalance();
              history.push("/dashboard");
            }
          });
        })
        .catch((error) => {
          setBulkLoading(false);
          console.error(
            "Bulk deposit failed:",
            error.response?.status,
            error.response?.data,
            error.message,
          );
          toast.error(error.response?.data?.message || "Bulk deposit failed", {
            position: toast.POSITION.TOP_LEFT,
          });
        });
    }
  };

  const onBeforeFinish = async (values) => {
    Swal.fire({
      title: "Deposit",
      text: `Deposit K${values.amount} to ${values.phone}?`,
      icon: "info",
      showCancelButton: true,
    }).then((result) => {
      if (result.isConfirmed) {
        onFinish(values);
      }
    });
  };

  const onFinish = async (values) => {
    if (parseFloat(values.amount) > parseFloat(person.balance) - 5) {
      toast.error("Insufficient Funds", {
        position: toast.POSITION.TOP_LEFT,
      });
    } else {
      try {
        setLoading(true);

        const newbalance =
          parseFloat(person.balance) - parseFloat(values.amount) - 5;

        const postData = {
          provider: values.provider,
          phone: values.phone,
          amount: values.amount,
          companyname: person.companyname,
          token: token,
          balance_id: person.balance_id,
          balance: person.balance,
          newbalance: newbalance,
          vtype: "Deposit",
        };

        await axios
          .post(`${process.env.REACT_APP_SERVER}/operation/deposit`, postData, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .then((response) => {
            form.resetFields();
            setLoading(false);
            setPhone("");
            setProvider("");
            setProviderTouched(false);
            setLookupResult(null);
            setLookupFailed(false);

            updateCgrate();
            refreshBalance();

            Swal.fire({
              title: `Deposit`,
              text: `Deposit was successful`,
              icon: "success",
            }).then((result) => {
              if (result.isConfirmed) {
                history.push("/dashboard");
              }
            });
          });
      } catch (error) {
        setLoading(false);
        toast.error("Someting went wrong", {
          position: toast.POSITION.TOP_LEFT,
        });

        console.error("Error submitting form:", error);
        // Handle error cases
      }
    }
  };

  const refreshBalance = () => {
    axios
      .get("https://cms.paysmart.co.zm/users/me?fields=*,balance.*", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      })
      .then(async (userResponse) => {
        setPerson({
          ...person,
          balance: userResponse.data.data.balance[0].balance,
        });
      })
      .catch((userError) => {
        console.log("Error fetching user data:", userError);
      });
  };

  return (
    <div className="layout-content">
      <Row gutter={16}>
        <Col xs={24} sm={24} md={12}>
          <Card>
            <Title level={5}>Single Number</Title>
            <Form name="myForm" onFinish={onBeforeFinish} form={form}>
              <Form.Item
                className="username"
                label="Mobile Operator"
                name="provider"
                rules={[
                  {
                    required: true,
                    message: "Please select mobile operator",
                  },
                ]}
              >
                <Select
                  placeholder="Select Mobile Operator"
                  onChange={handleProviderChange}
                >
                  <Option value="Airtel">Airtel</Option>
                  <Option value="MTN">MTN</Option>
                  <Option value="Zamtel">ZAMTEL</Option>
                </Select>
              </Form.Item>
              <Form.Item
                className="username"
                label="Phone Number"
                name="phone"
                initialValue={
                  location.state && location.state.phone
                    ? location.state.phone
                    : ""
                }
                rules={[
                  {
                    required: true,
                    message: "Please enter phone number",
                  },
                ]}
              >
                <Input
                  rules={[
                    {
                      required: true,
                      message: "Please enter phone number",
                    },
                  ]}
                  type="number"
                  placeholder="Phone starting with 0"
                  onChange={handlePhoneChange}
                />
              </Form.Item>
              {(lookupLoading || lookupResult || lookupFailed) && (
                <div style={{ marginTop: "-12px", marginBottom: "16px" }}>
                  {lookupLoading && (
                    <Text type="secondary">
                      <Spin size="small" style={{ marginRight: 8 }} />
                      Looking up account name...
                    </Text>
                  )}
                  {!lookupLoading && lookupResult && (
                    <Text type="success">
                      <CheckCircleFilled style={{ marginRight: 8 }} />
                      {lookupResult.fullName}
                    </Text>
                  )}
                  {!lookupLoading && lookupFailed && (
                    <Text type="secondary">
                      Couldn't verify this account -- double-check the number before sending.
                    </Text>
                  )}
                </div>
              )}

              <Form.Item
                className="username"
                label="Amount"
                name="amount"
                rules={[
                  {
                    required: true,
                    message: "Please enter amount",
                  },
                ]}
              >
                <Input
                  rules={[
                    {
                      required: true,
                      message: "Please enter amount",
                    },
                  ]}
                  type="number"
                  placeholder="Amount"
                  onChange={handleAmountChange}
                />
              </Form.Item>

              <Loader loading={loading} />
              <Text
                type="secondary"
                style={{ marginBottom: "16px", display: "block" }}
              >
                * Note, there is an additional K5 charge for each deposit
              </Text>

              <Form.Item>
                <Button type="primary" htmlType="submit">
                  Submit
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
        <Col xs={24} sm={24} md={12}>
          <Card>
            <Title level={5}>Bulk Deposit</Title>
            <Form name="myForm" onFinish={onFileUploaded}>
              <Form.Item className="username" label="Upload File">
                <Dragger {...props}>
                  <p className="ant-upload-drag-icon">
                    <FileExcelOutlined style={{ color: "green" }} />
                  </p>
                  <p className="ant-upload-text">
                    Click or drag file to this area to upload
                  </p>
                  <p className="ant-upload-hint">File must be in CSV Format</p>
                </Dragger>
              </Form.Item>
              <Loader loading={bulkloading} />
              <Text
                type="secondary"
                style={{ marginBottom: "16px", display: "block" }}
              >
                {" "}
                <Text
                  type="secondary"
                  style={{ marginBottom: "16px", display: "block" }}
                >
                  * Note, there is an additional K5 charge for each account
                  deposit
                </Text>
              </Text>
              <Form.Item>
                <Button type="primary" htmlType="submit">
                  Submit
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
      <ToastContainer />
    </div>
  );
};

export default Deposits;
